import React from 'react';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import highlighter from 'src/js/modules/highlighter';
import Trigger from 'src/js/modules/common/components/trigger';
import common from '../constants/common';
import selectors from '../constants/selectors';
import duplicateCompositeItem from '../helpers/duplicate-composite-item';
import trackDuplicateCompositeItem from '../trackers/track-duplicate-composite-item';

const { Icon } = designSystem;
const { COMPOSITE_WIDGET_DUPLICATED_TRIGGER_ID } = common;

const addCompositeGroupControl = {
  id: COMPOSITE_WIDGET_DUPLICATED_TRIGGER_ID,
  trigger: (
    <Trigger id={COMPOSITE_WIDGET_DUPLICATED_TRIGGER_ID}>
      <Icon glyph="copy" />
    </Trigger>
  ),
  onTriggerClick: (elementId, { getContext }) => {
    const { controlPane } = getContext();

    controlPane.hidePane();
    highlighter.operations.hide();
    duplicateCompositeItem({ elementId });
    trackDuplicateCompositeItem({ elementId });
  },
  matches: (liveElement) => liveElement.matches(selectors.COMPOSITE_ITEM),
  highlightElement: (element) => [element.closest(selectors.COMPOSITE_GROUP)],
  get tooltip() {
    return i18next.t('Duplicate');
  },
  priority: 50,
};

export default addCompositeGroupControl;
